import React from 'react'
import styles from './wealth.scss'
import wealth from '../../../common/images/solution/wealth.jpg'
import yd_wealth from '../../../common/images/solution/yd-wealth.png'
import one from '../../../common/images/solution/01.png'
import two from '../../../common/images/solution/02.png'
import three from '../../../common/images/solution/03.png'
import four from '../../../common/images/solution/04.png'
import circular from '../../../common/images/solution/circular.png'
import solutions from '../../../common/images/solution/solution.png'
import wealth_1 from '../../../common/images/solution/wealth-1.jpg'
import wealth_2 from '../../../common/images/solution/wealth-2.jpg'
import wealth_3 from '../../../common/images/solution/wealth-3.jpg'
import wealth_4 from '../../../common/images/solution/wealth-4.jpg'
import wealth_5 from '../../../common/images/solution/wealth-5.jpg'
import one_x from '../../../common/images/solution/01-x.png'
import two_x from '../../../common/images/solution/02-x.png'
import three_x from '../../../common/images/solution/03-x.png'
import fous_x from '../../../common/images/solution/04-x.png'

const Wealth = (props) => {
  return <section className={styles['wealth']}>
    <div className={styles['bill']}>
      <img src={wealth} alt='wealth' className={styles['bill_img']} />
      <img src={yd_wealth} alt='yd_wealth' className={styles['bg_bill_img']} />
      <div className={styles['bill-content']}>
        <h2>智能财税</h2>
        <p>降“本”增“效”，助力企业财务数字化转型。</p>
      </div>
    </div>
    <div className={styles['industry-pain']}>
      <h3>行业痛点</h3>
      <ul>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={one} alt='01' className={styles['industry-one']} /></div>
            <h4>人工生单耗时久</h4>
          </div>
          <div className={styles['industry-p']}>
            <span></span>
            <p>
            财务票据数量多、类型杂，财务人员人工处理、核对耗时久又费心。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={two} alt='02' /></div>
            <h4>税收风险无预警</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s2']}></span>
            <p>
            人工检查易出现纰漏，或者因为经验局限未发现账上的潜在风险。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={three} alt='03' /></div>
            <h4>查账查票不便利</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s3']}></span>
            <p>
            异地办公想要查账查票还要找个地方开电脑、登账号，没有随身带电脑就只能干瞪眼，十分无奈。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={four} alt='04' /></div>
            <h4>申报数据多</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s4']}></span>
            <p>
            企业申报报表张数多、勾稽校验杂、填报耗时久，需要逐一计算填写费时又费力。
            </p>
          </div>
        </li>
      </ul>
      <img src={solutions} alt='solutions' className={styles['solutions']} />
      <img src={circular} alt='circular' className={styles['circular']} />
    </div>
    <div className={styles['scheme']}>
      <h3>解决方法</h3>
      <p className={styles['scheme-wz']}>降“本”增“效”，助力企业财务数字化转型。</p>
      <div className={styles['scheme_content']}>
        <img src={wealth_1} alt='wealth_1' className={styles['gather']} />
        <div>
          <img src={one_x} alt='one-x' className={styles['one-x']} />
          <h4>发票及银行流水智能生单</h4>
          <p>
          快速获取发票及电票原件，支持各种银行格式导入，支持银行流水及回单的直接获取，后台按规则预生成凭证，用户核对后一键生成凭证，凭证联查原件。
          </p>
        </div>
      </div>
      <div className={`${styles.scheme_content}`}>
        <div className={`${styles.scheme_two}`}>
          <img src={two_x} alt='two-x' className={styles['two-x']} />
          <h4>成本清单自动生成凭证</h4>
          <p>
          期末存货成本支持按明细结转、全额结转、毛利法结转、销量结转、EXCEL导入等多种结转方式，清单自动生成凭证PDF附件。
          </p>
        </div>
        <img src={wealth_2} alt='wealth_2' className={styles['fetch']} />
      </div>
      <div className={styles['scheme_content']}>
        <img src={wealth_3} alt='wealth_3' className={styles['print']} />
        <div className={`${styles.scheme_three}`}>
          <img src={three_x} alt='three-x' className={styles['three-x']} />
          <h4>风险检测，财务报告</h4>
          <p>
          月末做账规范检测，生成对应分析报告，支持生成长图导出；用户可于系统内查看企业月度报告、年度报告，全面把控企业财务动态。
          </p>
        </div>
      </div>
      <div className={styles['scheme_content']}>
        <div className={`${styles.scheme_fous}`}>
          <img src={fous_x} alt='fous-x' className={styles['fous-x']} />
          <h4>小程序即时查账查发票</h4>
          <p>
          随时查看凭证及账簿、月度报表、财务报表、经营状况、进销项发票、开票及报税情况、风险分析等，让企业管理更高效；且支持电票原件上传，便于生成凭证附件及电子归档案。
          </p>
        </div>
        <img src={wealth_4} alt='wealth_4' className={styles['ticket']} />
      </div>
      <div className={styles['scheme_content']}>
        <img src={wealth_5} alt='wealth_5' className={styles['wealth-5']} />
        <div className={`${styles.scheme_five}`}>
          <div className={styles['five-x']}>05</div>
          <h4>一键申报</h4>
          <p>
          支持多账套、多税种当月一键零申报，极大提高财务报税效率，降低企业时间成本。
          </p>
        </div>
      </div>
    </div>
  </section>
}

export default Wealth
